// extracted by mini-css-extract-plugin
export default {"root":"aSUKm2ychllqoRbdhsA5"};